import React from 'react'
import hulk from '../assets/hulk.webp'
import hulk1 from '../assets/hulk1.webp'
import hulk2 from '../assets/hulk2.webp'
import { Link } from 'react-router-dom'
import hulk3 from '../assets/hulk3.png'
import hulk5 from '../assets/hulk5.webp';
import hulk6 from '../assets/hulk6.jpeg';
import hulk7 from '../assets/hulk7.webp';
import logo2 from '../assets/logo2.png';
// import Nothing from './Nothing/Nothing'







function Logo() {
  return (
    <>
      <div className="logo relative">
        <div className="logo-img  ">
          <div className='absolute bottom-6  md:bottom-6 lg:top-6  '>
             <div className=" items-center pt-[12rem] pl-[5rem]">
            <img src={hulk} alt=" hulk" className="h-[8rem] w-[40] " />
            <div className="flex pl-[8rem]">
              <p className="text-white">Stream Now On Disney+</p>
            </div>
          </div>
          <div className="my-4  pl-[10rem] ">
            <button className="text-white bg-[#6161ec] hover:bg-[#2f2fcf] px-6 py-3 rounded-[50px] w-[230px]  h-12 font-bold text-[16px]">
              SUBSCRIBE NOW*
            </button>
          </div>
          </div>
         
        </div>
      </div>

      <div className="bg-[#1f1f66]  w-[100%] h-auto">
        <div className="flex flex-col md:flex-row  pt-10">
          <div className="mx-12 hover:shadow-lg">
            <Link to='/Nothing'>

            <img src={hulk1} alt="" className="w-full h-[330px] " />
              <div className="bg-white p-4 h-40">
                <h1 className="font-[500] pb-3 leading-8 tracking-wide">
                 
                  l am Groot: Groot's First Steps
                </h1>
                <p >
                  Baby Groot takes his first steps outside his pot, but dicovers
                  he shouldn't want too much
                </p>
                <h2 className="text-[12px] font-bold pt-4">DISNEY+</h2>
              </div>
            </Link>
          </div>

          <div className="pt-10 md:pt-0 mx-12 hover:shadow-lg">
             <Link to='/Nothing'>
            <img src={hulk2} alt="" className="w-full h-[330px]" />
           
              <div className="bg-white p-4 h-40">
                <h1 className="font-[500] pb-3 leading-8 tracking-wide">
                 
                  light year
                </h1>
                <p>
                  Buzz lightyear teams up with newbies against a familiar foe.
                </p>
                <h2 className="text-[12px] font-bold pt-4">DISNEY+</h2>
              </div>
            </Link>
          </div>
        </div>
        <div className="pt-5 flex justify-center items-center">
          <img src={hulk3} alt="" className="w-[800px]" />
        </div>
        <div className="my-7  flex justify-center items-center ">
          <button className="text-white bg-[#6161ec] hover:bg-[#2f2fcf] px-6 py-3 rounded-[50px] w-[230px]  h-12 font-bold text-[16px]">
            SUBSCRIBE NOW*
          </button>
        </div>
        <div className="flex justify-center items-center text-white pb-4">
          <p>*Conditions apply |$8.99/month or $89.90/year</p>
        </div>
      </div>
      <div className="bg-[#faf6f6]">
        <div className="flex justify-center items-center font-[600px] text-3xl pt-10">
          <p>Parks</p>
        </div>
        <div className="p-8 logo-2">
          <div className=" logo2 h-auto">
            <div className='pt-16'>
              <div className="flex justify-end">
              <img src={hulk5} alt="" className="w-[350px] " />
            </div>
            <div className="text-white flex justify-end p-4">
              <p>An epic new themed land, now open at Disneyland</p>
            </div>
            <div className="flex justify-end text-white pr-[10rem]">
              <p>Paris!</p>
            </div>
            <Link
              to="/"
              className="flex justify-end text-white pr-[8rem] hover:underline"
            >
              BOOK NOW
            </Link>
            </div>
            
          </div>
        </div>

        <div className="flex flex-col md:flex-row  pt-10">
          <div className="mx-12 hover:shadow-lg">
            <img src={hulk6} alt="" className="w-full h-[330px] " />
            <Link to="/Nothing">
              <div className="bg-white p-4 h-40">
                <h1 className="font-[500] pb-3 leading-8 tracking-wide">
                 
                  Summer 2023 destinations
                </h1>
                <p>
                  Book now.More information
                </p>
                <h2 className="text-[12px] font-bold pt-4">DISNEY CRUISE LINE</h2>
              </div>
            </Link>
          </div>

          <div className=" pt-10 md:pt-0 mx-12 hover:shadow-lg">
            <Link to='/Nothing'>
            <img src={hulk7} alt="" className="w-full h-[330px]" />
            
              <div className="bg-white p-4 h-40">
                <h1 className="font-[500] pb-3 leading-8 tracking-wide">
                 
                  Disney Parks Tickets '22
                </h1>
                <p>
                  Celebrate the 50th anniversary of Walt Disney World with us!
                </p>
                <h2 className="text-[12px] font-bold pt-4">WALT DISNEY WORLD</h2>
              </div>
            </Link>
          </div>
        </div>
        <div className="flex justify-center items-center font-[600px] text-3xl pt-10">
          <p>Shop</p>
        </div>
        <div className=" logo-3 px-16 ">
          <div className=" logo3 h-auto">
            <div className='pt-16 px-20'>
              <div className="">
                <img src={logo2} alt=""className='w-[13%]' />
            </div>
            <div className=''>
                <div>
                  <p>The very best of Disney,Pixar,Star Wars and Marvel in one place</p>
                </div>
                <div className='font-bold pt-10'>
                  <p>SHOP NOW</p>
                </div>
            </div>
            </div>
            
          </div>
        </div>
        
      </div>
    </>
  )
}

export default Logo
